import { defineComponent as n, resolveComponent as t, openBlock as i, createElementBlock as s, createVNode as a, createCommentVNode as r } from "vue";
import c from "../../atoms/VSpinner/VSpinner.js";
import { _ as p } from "../../../_plugin-vue_export-helper-dad06003.js";
const d = n({
  name: "VLoadingSection",
  components: {
    VSpinner: c
  },
  props: {
    isLoading: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Number,
      default: 48
    }
  }
});
const _ = {
  key: 0,
  class: "hobi-loading-section"
};
function l(e, m, f, u, V, g) {
  const o = t("VSpinner");
  return e.isLoading ? (i(), s("div", _, [
    a(o, {
      color: "#FF7E21",
      size: e.size
    }, null, 8, ["size"])
  ])) : r("", !0);
}
const L = /* @__PURE__ */ p(d, [["render", l], ["__scopeId", "data-v-9934ad47"]]);
export {
  L as default
};
